import React from "react";
import styled from "styled-components";

// ----------------------------------------------------------------------------

function _SystemPickPoint(props) {
  const { style, top, left, small, icon, onPress } = props;

  return (
    <div
      onClick={onPress}
      className="pickPoint"
      style={{
        position: "absolute",
        top: `${top}%`,
        left: `${left}%`,
        //backgroundColor: "rgba(0,0,0,0.3)",
        height: small ? 100 : icon ? 50 : 200,
        width: small ? 100 : icon ? 50 : 200,
      }}
    ></div>
  );
}
const SystemPickPoint = styled(_SystemPickPoint)`
  & {
    .pickPoint {
      background-color: ;
    }
  }
`;
export default SystemPickPoint;
